import React, { PropsWithChildren } from "react"

import { useTranslations } from "@cirrus/core/i18n"

import { useCustomerInfo } from "../../CustomerInfo"

export const WithLoginPageFallback = ({ children }: PropsWithChildren) => {
	const customerInfo = useCustomerInfo()
	const { translations } = useTranslations()

	const customerInfoIsReady = !!customerInfo.data
	const translationsAreReady = !!translations

	// TODO: Add the fallback component (if needed)
	return <>{customerInfoIsReady && translationsAreReady ? children : null}</>
}
